<template>
  <div>
    <Row>
      <Col :span="18">
      <table class="params-table">
        <tr v-for="item in duanDaokaDataLight" :key="item.key">
          <td class="label">{{item.key}}：</td>
          <td>{{item.value}}</td>
        </tr>
      </table>
      </Col>
      <Col :span="6" class="text-right">
      <e-image fit="contain" style="height: 80px;" src="static/daoka/duanDaoka.png"
               :preview-src-list="['static/daoka/duanDaoka.png']" />
      </Col>
    </Row>

    <!-- <Table :data="duanDaokaDataLight" :columns="[
        { title: 'key', key: 'key', width: 200 },
        {
          title: 'value',
          key: 'value',
          render: (h, params) => {
            return tableFmt(h, params, 'value');
          }
        }
      ]" style="width: 100%" :show-header="false">
    </Table> -->
    <!-- <div class="title">短刀卡配纸方案</div>
    <Table :data="zhixiangData" :columns="[
        { title: '配置方案', key: 'peizhi', width: 200 },
        {
          title: '品牌',
          key: 'pinpai',
          render: (h, params) => {
            return tableFmt(h, params, 'pinpai');
          }
        },
        {
          title: '克重',
          key: 'kezhong',
          render: (h, params) => {
            return tableFmt(h, params, 'kezhong');
          }
        },
        {
          title: '环压',
          key: 'huanya',
          render: (h, params) => {
            return tableFmt(h, params, 'huanya');
          }
        }
      ]" style="width: 100%">
    </Table> -->
  </div>
</template>

<script>
import { PackageInfo } from '@/utils/mixins'
import { isNumber } from 'loadsh'
export default {
  mixins: [PackageInfo],
  inject: {
    zhixiangData: {
      default: () => ({})
    }
  },
  data () {
    return {
      duanDaokaDataLight: [
        {
          key: '短刀卡尺寸(mm)',
          value: ''
        },
        {
          key: '短刀卡数量',
          value: ''
        }, {
          key: '材料',
          value: ''
        }
      ]
    }
  },
  created () {
    this.assignDaokaDataLight(this.packageInfo)
  },
  methods: {
    assignDaokaDataLight (info) {
      const daokaInfo = info.packageinfo.auxiliary || {}
      // 短刀卡
      this.duanDaokaDataLight[0].value = `${daokaInfo.shortDaokaLong ||
        '---'} * ${daokaInfo.shortDaokaWidth || '---'} mm`
      this.duanDaokaDataLight[1].value = daokaInfo.shortDaokaAmount
      const lengxing = this.zhixiangData.find(e => e.peizhi === '楞型')
      const lengxingName = lengxing ? ' ' + lengxing.kezhong : ''
      this.duanDaokaDataLight[2].value = this.$get(this.zhixiangData, '[0].pinpai') + ' ' + this.zhixiangData.filter(e => e.kezhong && isNumber(e.kezhong)).map(e => e.kezhong).join('/') + lengxingName + ' ' + this.$get(this.packageInfo, 'packageinfo.packageMaterialPlan.px', '') + 'N/m'
      // // 长刀卡
      // this.changDaokaDataLight[1].value = `${daokaInfo.longDaokaLong ||
      //   '---'} * ${daokaInfo.longDaokaWidth || '---'} mm`
      // this.changDaokaDataLight[2].value = daokaInfo.longDaokaAmount
      // // 平卡
      // this.pingkaDataLight[1].value = `${daokaInfo.pingkaLong ||
      //   '---'} * ${daokaInfo.pingkaWidth || '---'} mm`
      // this.pingkaDataLight[2].value = daokaInfo.pingkaAmount
    },
    tableFmt (h, params, key) {
      if (typeof params.row[key] === 'number') {
        return h('span', params.row[key])
      }
      return h('span', params.row[key] || '---')
    },
    updateData () {
      this.assignDaokaDataLight(this.packageInfo)
    }
  }

}
</script>

<style lang="scss" scoped></style>
